
















import { defineComponent, PropType } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import { useSearchPostContentPlainExcerpt } from '../../composables/global_search/useSearchPostContentPlainExcerpt';
import KeywordHighlight from 'vue-text-highlight';
import WordHighlight from './WordHighlight.vue';

export default defineComponent({
  name: 'SearchResultItemPostBody',
  components: { KeywordHighlight },
  props: {
    post: { type: Object as PropType<PostModel>, required: true },
    searchString: { type: String, default: '' },
    searchQueries: { type: [String, Array], default: '' },
  },
  setup(props) {
    const { contentPlainExcerpt } = useSearchPostContentPlainExcerpt(
      () => props.post.content?.html ?? '',
      () => props.searchString
    );

    return { contentPlainExcerpt, WordHighlight };
  },
});
